//Background colors
const fontFamily = {
  main: "'Open Sans', 'sans-serif'"
}

export default fontFamily



// WEBPACK FOOTER //
// ./src/global/fonts.js